import { Component, OnDestroy, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { ComanageInvoice } from 'src/app/models/ComanageInvoice';

import { FetchInvoices } from '../comanage.actions';
import { ComanageState } from '../comanage.state';

@Component({
    selector: 'app-comanage-invoices',
    templateUrl: './comanage-invoices.component.html',
    styleUrls: ['./comanage-invoices.component.scss'],
})
export class ComanageInvoicesComponent implements OnDestroy {
    private subscriptions = new Subscription();

    @Select(ComanageState.invoices) coManageInvoices$: Observable<any[]>;
    isset: boolean;
    filter: string;
    isLoading = true;

    // material table
    displayedColumns: string[] = ['title', 'contact.name', 'totals.total', 'due_date', 'status', 'pdf'];
    dataSource: MatTableDataSource<ComanageInvoice>;

    @ViewChild(MatSort, { static: true }) sort: MatSort;
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

    constructor(private store: Store) {}

    checkCredentials(set: boolean) {
        this.isset = set;
        this.prepareDataTable();
    }

    /* setup mattable with invoices */
    prepareDataTable() {
        this.subscriptions.add(
            this.coManageInvoices$.subscribe((invoices) => {
                if (!invoices) {
                    this.store.dispatch(new FetchInvoices()).subscribe();
                } else {
                    this.dataSource = new MatTableDataSource(invoices);
                    this.dataSource.sort = this.sort;
                    this.dataSource.paginator = this.paginator;

                    this.dataSource.sortingDataAccessor = (item, property) => {
                        if (property.includes('.')) return property.split('.').reduce((o, i) => o[i], item);
                        return item[property];
                    };

                    this.dataSource.filterPredicate = (data: ComanageInvoice, filter: string) => {
                        if (data.title.toLocaleLowerCase().includes(filter.toLocaleLowerCase())) {
                            return true;
                        } else if (data.contact != undefined && data.contact.name.toLocaleLowerCase().includes(filter.toLocaleLowerCase())) {
                            return true;
                        } else if (data.status != undefined && data.status.toLocaleLowerCase().includes(filter.toLocaleLowerCase())) {
                            return true;
                        } else if (data.due_date != undefined && data.due_date.toLocaleLowerCase().includes(filter.toLocaleLowerCase())) {
                            return true;
                        } else return false;
                    };
                    this.isLoading = false;
                }
            }),
        );
    }

    applyFilter(filterValue) {
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
